<template>
<div class="chapter">
<div class="inner_page">
<p class="imagea"><a id="page_xiii"></a><img alt="Image" src="images/watch.jpg"/></p>
<h2 class="h2b"><a id="frontmatter01"></a><span class="boxnote3a">F<span class="small">OREWORD</span></span></h2>
<p class="linespace"> </p>
<h2 class="h2c"><a id="frontmatter01section01"></a><strong><em>How to get more dates.</em></strong></h2>
<p class="para">My search for dates landed me with the company that has the largest sales training program in the world: Xerox Corporation.</p>
<p class="indent-para">When I got out of college in 1976, my goal in life was to sell medical supplies. That’s because a guy who’s 21 years old thinks with one thing: testosterone. My brain said: medical supplies… nurses… dates.</p>
<p class="indent-para">I couldn’t get a job selling medical supplies. Some guys who lived in my apartment building worked for Xerox, and they said, “Why don’t you come work for Xerox?” I told them, “I don’t want to sell copiers. I want to sell medical supplies.” That was in May. In September my money was running out, so I decided to go for a job at Xerox. After six or seven interviews, I got hired.</p>
<p class="indent-para">I thought to myself, “This is not a bad company. They have about 11,000 salespeople and a great sales training program. I’ll stay here one year, get this great training, make myself marketable – and then I’ll go sell medical supplies.”</p>
<p class="indent-para"><a id="page_xiv"></a>The training was unbelievable. The sessions ran three weeks at a time, 12-14 hours a day – and night. Xerox spent millions of dollars developing and improving on all these sales tools they had picked up from everyone else.</p>
<p class="indent-para">The first year I did pretty well. I was in the top 20% of our branch. I thought, “I’ll apply all this information. I’ll take the stuff they’re telling me and just work harder than the next guy.” In my second year at Xerox, in 1977, I was number one in the entire U.S. I thought, “Wow! I think I’ll stay awhile…”</p>
<p class="indent-para">I am not an exception. In 1983 Xerox did a study of its 500 top salespeople and found that:</p>
<p class="para"> </p>
<p class="center-parac"><em>Diligent application makes the difference between<br/>an average salesperson and a successful salesperson.</em></p>
<p class="indent-para">It’s all in the application of skills. I did it. And so can you.</p>
<p class="indent-para">In this book, I talk a lot about dating, buying electronics, and buying a car because they are experiences we can all relate to. If I break sales down into common-sense things we all do, you can more readily apply them to selling.</p>
<p class="indent-para">Every day I work with people who are new to sales and have never sold before. I also work with people who have been selling for years, except they’ve never sold either – because most salespeople don’t do it right.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?25e78a44